import WRAP from "WRAP-JS";
import { _orderBy, formatBaseTime, formatValidTime, parseUTCDate } from "../../../utils/FPEUtils";
import LegendSigwx from "../legend/LegendSigwx";
import {
  configSigwxDhUkHigh,
  configSigwxDhUkMiddle,
  configSigwxDhUsHigh,
  configSigwxDhUsMiddle, configSigwxLayer
} from "./config/ConfigSigwx";
import { WX_ID_SIGWX } from "../../../store/WeatherContentsState";

export const SIGWX_WASHINGTON = "WX_USWAFC_SIGWX";
export const SIGWX_LONDON = "WX_UKWAFC_SIGWX";

class Sigwx {

  static NAME = WX_ID_SIGWX;
  dataSource;
  changeDataSourceFlg = false;
  ready = false;
  dhUSHigh;
  dhUSHighORGData;
  dhUSMiddle;
  dhUSMiddleORGData;
  dhUKHigh;
  dhUKHighORGData;
  dhUKMiddle;
  dhUKMiddleORGData;
  layerUSHigh;
  layerUSMiddle;
  layerUKHigh;
  layerUKMiddle;
  layerConfig;
  addingLayerConfig;
  altitude;
  etd;
  elapsed = 0;
  dispatcher;

  typeInitialized = {
    [SIGWX_WASHINGTON]: false,
    [SIGWX_LONDON]: false
  };

  typeTimeInfo = {
    [SIGWX_WASHINGTON]: {
      baseTime: '---',
      validTime: '---'
    },
    [SIGWX_LONDON]: {
      baseTime: '---',
      validTime: '---'
    }
  };

  constructor(altitude) {
    this.dataSource = SIGWX_LONDON;
    this.altitude = altitude;

    this.layerUSHigh = new WRAP.Geo.Layer('SIGWX_US_HIGH');
    this.layerUSMiddle = new WRAP.Geo.Layer('SIGWX_US_MIDDLE');
    this.layerUKHigh = new WRAP.Geo.Layer('SIGWX_UK_HIGH');
    this.layerUKMiddle = new WRAP.Geo.Layer('SIGWX_UK_MIDDLE');
    this.layerUSHigh.setVisible(false);
    this.layerUSMiddle.setVisible(false);
    this.layerUKHigh.setVisible(false);
    this.layerUKMiddle.setVisible(false);
    this.layerUSHigh.disableInteraction(true);
    this.layerUSMiddle.disableInteraction(true);
    this.layerUKHigh.disableInteraction(true);
    this.layerUKMiddle.disableInteraction(true);
  }

  setDispatcher(dispatcher) {
    this.dispatcher = dispatcher;
  }

  async initialize(dataType) {
    await this.initData(dataType);
    this.initLayer(dataType);
    this.ready = true;
  }

  initData(dataType) {
    return new Promise(allResolve => {

      let dhHigh;
      let dhMiddle;
      let layerHigh;
      let layerMiddle;

      let status = 'pending';

      if (dataType === SIGWX_WASHINGTON) {
        dhHigh = this.dhUSHigh = new WRAP.Data(configSigwxDhUsHigh);
        dhMiddle = this.dhUSMiddle = new WRAP.Data(configSigwxDhUsMiddle);
        layerHigh = this.layerUSHigh;
        layerMiddle = this.layerUSMiddle;
      } else if (dataType === SIGWX_LONDON) {
        dhHigh = this.dhUKHigh = new WRAP.Data(configSigwxDhUkHigh);
        dhMiddle = this.dhUKMiddle = new WRAP.Data(configSigwxDhUkMiddle);
        layerHigh = this.layerUKHigh;
        layerMiddle = this.layerUKMiddle;
      }

      const highPromise = new Promise(resolve => {
        dhHigh.updated('timelist', (ref) => {
          if (status === 'fulfilled') {
            this._selectBaseValidTime(ref, dataType);
          }
          resolve(ref);
        });
      });

      const middlePromise = new Promise(resolve => {
        dhMiddle.updated('timelist', (ref) => {
          if (status === 'fulfilled') {
            this._selectBaseValidTime(ref, dataType);
          }
          resolve(ref);
        });
      });

      Promise.all([highPromise, middlePromise]).then(refs => {
        allResolve(refs);
        status = 'fulfilled';
        //highの時制
        this._selectBaseValidTime(refs[0]);
      });

      let highDataResolve = false;
      let middleDataResolve = false;

      dhHigh.updated('data', data => {
        highDataResolve = true;
        if (dataType === SIGWX_WASHINGTON) {
          this.dhUSHighORGData = JSON.parse(JSON.stringify(data));
        } else if (dataType === SIGWX_LONDON) {
          this.dhUKHighORGData = JSON.parse(JSON.stringify(data));
        }
        this._filterWRAPData(data);

        if (middleDataResolve) {
          this._distinctHighMiddle(dhHigh, dhMiddle);
          layerHigh.invalidate();
          layerMiddle.invalidate();
          highDataResolve = false;
          middleDataResolve = false;
        }
      });

      dhMiddle.updated('data', data => {
        middleDataResolve = true;
        if (dataType === SIGWX_WASHINGTON) {
          this.dhUSMiddleORGData = JSON.parse(JSON.stringify(data));
        } else if (dataType === SIGWX_LONDON) {
          this.dhUKMiddleORGData = JSON.parse(JSON.stringify(data));
        }

        this._filterWRAPData(data);

        if (highDataResolve) {
          this._distinctHighMiddle(dhHigh, dhMiddle);
          layerHigh.invalidate();
          layerMiddle.invalidate();
          highDataResolve = false;
          middleDataResolve = false;
        }
      });

      this.typeInitialized[dataType] = true;

    });
  }

  initLayer(dataType) {
    this.layerConfig = configSigwxLayer;
    if (dataType === SIGWX_WASHINGTON) {
      this.layerUSHigh.configure(this.dhUSHigh, this.layerConfig);
      this.layerUSMiddle.configure(this.dhUSMiddle, this.layerConfig);

    } else if (dataType === SIGWX_LONDON) {
      this.layerUKHigh.configure(this.dhUKHigh, this.layerConfig);
      this.layerUKMiddle.configure(this.dhUKMiddle, this.layerConfig);
    }
  }

  async drawLayer(visible) {
    this.visible = visible;
    if (!this.typeInitialized[this.dataSource]) {
      await this.initialize(this.dataSource);
    }
    this.setVisible(this.visible);
  }

  getLayer() {
    return [this.layerUSHigh, this.layerUSMiddle, this.layerUKHigh, this.layerUKMiddle];
  }

  setVisible(visible) {
    if (!this.typeInitialized[this.dataSource]) {
      return;
    }

    if (this.dataSource === SIGWX_WASHINGTON) {
      this._usVisible(visible);
    } else {
      this._ukVisible(visible);
    }
    this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});
  }

  getTimeInformation() {
    const base = this.typeTimeInfo[this.dataSource].baseTime;
    const valid = this.typeTimeInfo[this.dataSource].validTime;
    const baseTime = base !== '---' ? formatBaseTime(base) : base;
    const validTime = valid !== '---' ? formatValidTime(valid) : valid;
    return {
      id: Sigwx.NAME,
      label: 'SIGWX',
      baseTime: baseTime,
      validTime: validTime
    }
  }

  getLegend() {
    return {
      id: Sigwx.NAME,
      label: 'SIGWX',
      component: LegendSigwx,
      contents: this
    };
  }

  applyAltitude(altitude) {
    this.altitude = altitude;
    if (this.dataSource === SIGWX_WASHINGTON) {
      if (this.dhUSHigh && this.dhUSHigh) {
        this.dhUSHigh.clearCache();
        this.dhUSMiddle.clearCache();
        this.dhUSHigh.update('data', this.dhUSHighORGData);
        this.dhUSMiddle.update('data', this.dhUSMiddleORGData);
      }
    } else {
      if (this.dhUKHigh && this.dhUKHigh) {
        this.dhUKHigh.clearCache();
        this.dhUKMiddle.clearCache();
        this.dhUKHigh.update('data', this.dhUKHighORGData);
        this.dhUKMiddle.update('data', this.dhUKMiddleORGData);
      }
    }
    this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});
  }

  applyElapsed(elapsed) {
    this.elapsed = elapsed;

    if (!this.ready) return;

    if (this.dataSource === SIGWX_WASHINGTON) {
      this._selectBaseValidTime(this.dhUSHigh.retained.timelist);
    } else {
      this._selectBaseValidTime(this.dhUKHigh.retained.timelist);
    }
  }

  applyPlanETD(etd) {
    this.etd = etd;

    if (!this.ready) return;

    if (this.dataSource === SIGWX_WASHINGTON) {
      this._selectBaseValidTime(this.dhUSHigh.retained.timelist);
    } else {
      this._selectBaseValidTime(this.dhUKHigh.retained.timelist);
    }
  }

  getDataSource() {
    return this.dataSource;
  }

  async setDataSource(dataSource) {
    this.changeDataSourceFlg = true;

    if (!this.typeInitialized[dataSource]) {
      await this.initialize(dataSource);
    }
    //現在のデータソースを非表示
    this.setVisible(false);
    this.dataSource = dataSource;
    //切り替え後のデータソースに高度を反映
    this.applyAltitude(this.altitude);
    //切り替え後のデータソースを表示
    this.setVisible(true);
  }

  _usVisible(visible) {
    if (this.layerUSHigh.visible() === visible) {
      return false;
    }
    if (visible) {
      this.layerUSHigh.show();
      this.layerUSMiddle.show();
    } else {
      this.layerUSHigh.hide();
      this.layerUSMiddle.hide();
    }
    this.dhUSHigh.setAutoUpdate('timelist', visible);
    this.dhUSMiddle.setAutoUpdate('timelist', visible);
    return true;
  }

  _ukVisible(visible) {
    if (this.layerUKHigh.visible() === visible) {
      return false;
    }
    if (visible) {
      this.layerUKHigh.show();
      this.layerUKMiddle.show();
    } else {
      this.layerUKHigh.hide();
      this.layerUKMiddle.hide();
    }
    this.dhUKHigh.setAutoUpdate('timelist', visible);
    this.dhUKMiddle.setAutoUpdate('timelist', visible);
    return true;
  }

  _updateDataset(dataType) {
    const time = this.typeTimeInfo[dataType];
    if (time.baseTime !== '---' && time.validTime !== '---') {
      if (this.dataSource === SIGWX_WASHINGTON) {
        this.layerUSHigh.set({
          basetime: time.baseTime,
          validtime: time.validTime
        });

        this.layerUSMiddle.set({
          basetime: time.baseTime,
          validtime: time.validTime
        });

      } else {
        this.layerUKHigh.set({
          basetime: time.baseTime,
          validtime: time.validTime
        });

        this.layerUKMiddle.set({
          basetime: time.baseTime,
          validtime: time.validTime
        });
      }

      this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});
    }
  }

  _filterWRAPData(data) {
    const ILLEGAL_ALTITUDE = "-99999";

    //高度フィルタ
    data.features = data.features.filter(feature => {
      const prop = feature.properties;

      let high = null;
      let low = null;
      if ( prop.contents_kind === "TURBULENCE" ) {
        if ( prop.altitudes.length === 1 ) {
          high = prop.altitudes[0];
        } else if ( prop.altitudes.length === 2 ) {
          low = prop.altitudes[0];
          high = prop.altitudes[1];
        }
      } else if ( prop.contents_kind === "CLOUD" ) {
        if (prop.cloud_distribution) {
          if (0 < prop.altitudes.length) high = prop.altitudes[0];
          if (1 < prop.altitudes.length) low = prop.altitudes[1];
        } else {
          if (prop.extended_degree) {
            if (prop.airframe_icing) {
              if (3 < prop.altitudes.length) {
                if (prop.altitudes[0] !== ILLEGAL_ALTITUDE) low = prop.altitudes[0];
                if (prop.altitudes[1] !== ILLEGAL_ALTITUDE) high = prop.altitudes[1];
              }
            } else {
              if (1 < prop.altitudes.length) {
                if (prop.altitudes[0] !== ILLEGAL_ALTITUDE) low = prop.altitudes[0];
                if (prop.altitudes[1] !== ILLEGAL_ALTITUDE) high = prop.altitudes[1];
              }
            }
          }
          if (prop.airframe_icing) {
            if (prop.extended_degree) {
              if (3 < prop.altitudes.length) {
                if (prop.altitudes[2] !== ILLEGAL_ALTITUDE) low = prop.altitudes[2];
                if (prop.altitudes[3] !== ILLEGAL_ALTITUDE) high = prop.altitudes[3];
              }
            } else {
              if (1 < prop.altitudes.length) {
                if (prop.altitudes[0] !== ILLEGAL_ALTITUDE) low = prop.altitudes[0];
                if (prop.altitudes[1] !== ILLEGAL_ALTITUDE) high = prop.altitudes[1];
              }
            }
          }
        }
      } else if ( prop.contents_kind === "STORM CENTRE" || prop.contents_kind === "VOLCANO" ) {
        //フィルタなし
        return true;
      } else if ( prop.contents_kind === "JET STREAM" ) {
        const tmp = feature.geometry.coordinates.reduce((accumulator, coordinate) => {
          coordinate.forEach(p => {
            if (p.length === 3) {
              accumulator.push(p[2]);
            }
          });
          return accumulator;
        }, []);

        const altitude = tmp.sort();
        low = altitude[0];
        high = altitude[altitude.length - 1];
      } else if ( prop.contents_kind === "TROPOPAUSE" ) {
        //Featureの中身のcoordinatesをフィルタする
        const newCoordinates = feature.geometry.coordinates.reduce((accumulator, points) => {
          if (points[2] && this._altitudeFilter(points[2], points[2])) {
            accumulator.push(points);
          }
          return accumulator;
        }, []);
        feature.geometry.coordinates = newCoordinates;
        return true;
      } else {
        //unknown
        return true;
      }
      feature.properties.altitudeForKey = `${high}_${low}`;
      return this._altitudeFilter(high, low);
    });
  }

  _altitudeFilter(_high, _low) {
    const fl1 = _high;
    const fl2 = _low;

    if (!fl1 && !fl2) {
      return true;
    }
    const low = fl2 ? flightLevel(fl2) : -1;
    const high = fl1 ? flightLevel(fl1) : -1;
    if (high !== -1 && low === -1 && this.altitude[0] > high) {
      return false;
    } else if (high === -1 && low !== -1 && this.altitude[1] < low) {
      return false;
    } else if (high !== -1 && low !== -1) {
      if (this.altitude[0] > high || this.altitude[1] < low) {
        return false;
      }
    }
    return true;
  }

  _distinctHighMiddle(high, middle) {
    const dupKey = feature => {
      let key;
      if ( feature.geometry && feature.properties && feature.properties.contents_kind) {
        key = feature.properties.contents_kind + feature.properties.altitudeForKey + feature.geometry.coordinates.join(':');
      }
      return key;
    }
    //重複データ除外用
    const duplicateCheck = high.retained.data.features.reduce((accumulator,feature) => {
      const key = dupKey(feature);
      if (key) {
        accumulator.add(dupKey(feature));
      }
      return accumulator;
    }, new Set());

    //middle側をフィルタリングする
    middle.retained.data.features = middle.retained.data.features.filter(feature => {
      const key = dupKey(feature);
      if (!key) return true;
      return !duplicateCheck.has(key);
    });
  }

  _selectBaseValidTime(ref, dataType=this.dataSource) {
    let timeList = ref;
    if (!timeList) return;
    timeList = timeList.timelist;

    let targetTime;
    if (!this.etd) {
      //プラン未選択時
      targetTime = Date.now();
    } else {
      //プラン選択時
      targetTime = this.etd.getTime() + this.elapsed * 1000;
    }

    const tmpTimeList = timeList.flatMap(base => {
      return base.validtime.map(validtime => {
        return {
          "validtime": validtime,
          "basetime": base.basetime,
          "validtime_msec": parseUTCDate(validtime).getTime()
        };
      });
    });

    // targetTimeに最も近いvalidを選択する(直近が過去時制と未来時制で同時刻の場合、未来時制のValidデータを採用する。)
    const sortedTimelist = _orderBy(tmpTimeList, [
      o => {
        return Math.abs(targetTime - o.validtime_msec);
      },
      'validtime'
    ], ['asc', 'desc']);

    const selectedTime = sortedTimelist[0];

    const baseTime = this.typeTimeInfo[dataType].baseTime;
    const validTime = this.typeTimeInfo[dataType].validTime;

    if (selectedTime && baseTime !== selectedTime.basetime && validTime !== selectedTime.validtime) {
      this.typeTimeInfo[dataType].baseTime = selectedTime.basetime;
      this.typeTimeInfo[dataType].validTime = selectedTime.validtime;
      this._updateDataset(dataType);
    }
    if (this.changeDataSourceFlg) {
      this._updateDataset(dataType);
      this.changeDataSourceFlg = false;
    }
  }
  
  _getSelectedFlightLevel() {
    const low = Math.min(...this.altitude);
    const high = Math.max(...this.altitude);
    let fl;
    if(low === 0) {
      fl = 'SFC';
    } else {
      fl = `FL${('000' + low).slice(-3)}`;
    }
    if(low !== high) {
      fl += ` - FL${('000' + high).slice(-3)}`;
    }
    return fl;
  }
}

function flightLevel(fl) {
  return (fl && Math.round(fl/30.48));
}


export default Sigwx;